var chopstickTabs = function() {

    var _tabNavigationItems = $('.js-tabs-nav > li');

    function activate(item) {
        var targetPane = $(item.find('a').attr('href'));

        // Reset all nav items in the tab navigation
        item.siblings().each(function() {
            $(this).removeClass('is-selected');
        });

        // Set the correct nav item active
        item.addClass('is-selected');

        // Reset all panes
        targetPane.siblings().each(function() {
            $(this).hide();
        });

        // Go to target pane
        targetPane.show();
    }

    // Bind click event to tab items
    _tabNavigationItems.on('click', function(e){
        // Prevent the default action on links
        e.preventDefault();

        // Switch tab to active
        activate($(this));
    });
};
